import React from "react";
import { graphql } from "gatsby";
import Helmet from "react-helmet";
import Page from "../components/page";

export const query = graphql`
    query PageQuery($id: String!) {
        page: sanityPage(id: { eq: $id }) {
            title
            id
            subtitle
            slug {
                current
            }
            cta_url
            cta_text
            cta_url_2
            cta_text_2
            intro_black
            intro_heading
            _rawIntro(resolveReferences: { maxDepth: 10 })
            intro {
                _rawChildren
                _type
                list
                style
                children {
                    _key
                    _type
                    text
                    marks
                }
            }
            modules {
                ... on SanityRace {
                    _type
                    id
                    title
                    mens_champion
                    mens_stages {
                        time
                        title
                        total
                        _key
                    }
                    womens_champion
                    womens_stages {
                        total
                        title
                        time
                        _key
                    }
                    details
                }
                ... on SanityMagnum {
                    _key
                    _type
                    _rawBody
                    body {
                        _key
                        _rawChildren(resolveReferences: { maxDepth: 10 })
                        _type
                        children {
                            marks
                            text
                            _type
                            _key
                        }
                        list
                        style
                    }
                }
                ... on SanityLargeImage {
                    _key
                    _type
                    image {
                        asset {
                            publicUrl
                        }
                    }
                }
                ... on SanityRoutes {
                    _key
                    _type
                    fineprint
                    full_route_line_1
                    full_route_line_2
                    full_route_embed
                    short_route_line_1
                    short_route_line_2
                    short_route_embed
                    heading
                }
                ... on SanityTwoImages {
                    _key
                    _type
                    background_black_white_hide
                    left_image {
                        asset {
                            publicUrl
                        }
                    }
                    right_image {
                        asset {
                            publicUrl
                        }
                    }
                }
                ... on SanityBannerlink {
                    _key
                    _type
                    link
                    heading
                    mainImage {
                        asset {
                            publicUrl
                        }
                    }
                }
                ... on SanityGalleryEmbed {
                    _key
                    _type
                    gallery_year
                    category
                }
                ... on SanityYoutube {
                    _key
                    _type
                    video_id
                }
                ... on SanityColumns1 {
                    _key
                    _type
                    _rawBody
                    _rawImage
                    centered
                    body {
                        style
                        list
                        _type
                        _rawChildren
                        _key
                        children {
                            text
                            marks
                            _type
                            _key
                        }
                    }
                    cta_link
                    cta_text
                    heading
                    underline
                    image {
                        asset {
                            publicUrl
                        }
                    }
                }
                ... on SanitySignupUltra {
                    _key
                    _type
                    heading
                    allow_magnum
                    allow_solo_pair
                }
                ... on SanitySignupGravel {
                    _key
                    _type
                    heading
                }
                ... on SanityPastEditions {
                    _type
                    title
                    past_edition {
                        title
                        slug {
                            current
                        }
                        mainImage {
                            asset {
                                publicUrl
                            }
                        }
                    }
                }
                ... on SanityColumns2 {
                    _key
                    _type
                    _rawBodyRight(resolveReferences: { maxDepth: 10 })
                    _rawBodyLeft(resolveReferences: { maxDepth: 10 })
                    cta_link
                    cta_text
                    underline
                    body_right {
                        style
                        list
                        _type
                        _rawChildren
                        _key
                        children {
                            text
                            marks
                            _type
                            _key
                        }
                    }
                    body_left {
                        style
                        list
                        _type
                        _rawChildren
                        _key
                        children {
                            text
                            marks
                            _type
                            _key
                        }
                    }
                    heading
                    intro
                }
                ... on SanityColumns3 {
                    _key
                    _type
                    _rawBodyCenter
                    _rawBodyLeft
                    _rawBodyRight
                    heading
                    heading_button_label
                    heading_button_url
                    body_right {
                        _key
                        _rawChildren
                        _type
                        list
                        style
                        children {
                            _key
                            _type
                            marks
                            text
                        }
                    }
                    body_left {
                        _key
                        _rawChildren
                        _type
                        style
                        list
                        children {
                            text
                            marks
                            _type
                            _key
                        }
                    }
                    body_center {
                        _key
                        _rawChildren
                        _type
                        list
                        style
                        children {
                            _key
                            _type
                            marks
                            text
                        }
                    }
                }
                ... on SanityImageText {
                    _key
                    _type
                    heading
                    body {
                        _key
                        _rawChildren
                        _type
                        list
                        style
                        children {
                            text
                            marks
                            _type
                            _key
                        }
                    }
                    image {
                        asset {
                            publicUrl
                        }
                    }
                    swap_image_text
                }
                ... on SanitySlideshow {
                    _key
                    _type
                    _rawImages
                    title
                    background_black_white
                    images {
                        _key
                        _type
                        _rawHotspot
                        _rawCrop
                        _rawAsset
                        asset {
                            publicUrl
                        }
                    }
                }
                ... on SanitySector {
                    _key
                    _type
                    _rawBody
                    heading
                    mainImage {
                        asset {
                            publicUrl
                        }
                    }
                    mapImage {
                        asset {
                            publicUrl
                        }
                    }
                    logoImage {
                        asset {
                            publicUrl
                        }
                    }
                    body {
                        _key
                        _rawChildren
                        _type
                        list
                        style
                        children {
                            _key
                            _type
                            marks
                            text
                        }
                    }
                }
                ... on SanitySection {
                    _key
                    _type
                    _rawBody
                    heading
                    hide_hr
                    body {
                        _key
                        _rawChildren
                        _type
                        list
                        style
                        children {
                            _key
                            _type
                            marks
                            text
                        }
                    }
                }
            }
            mainImage {
                asset {
                    publicUrl
                }
            }
        }
    }
`;

const PageTemplate = (props) => {
    const { data, errors } = props;

    const page = data && data.page;

    return (
        <div>
            <Helmet
                bodyAttributes={{
                    class: "page",
                }}
            />
            {page && <Page {...page} path={props.location.pathname} />}
        </div>
    );
};

export default PageTemplate;
